module.exports = __webpack_public_path__ + "static/media/asparagus.443b37bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asparagus.jpg
// module id = 33
// module chunks = 0